import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { FereastraDublura } from './components/FereastraDublura'
import { Toaster } from 'sonner'
import { App } from './App'
import { ConfirmareProvider } from './components/ui/Confirmare'
import { AvizVersiuneNoua } from './components/AvizVersiuneNoua'
import './index.css'
import { aplicaTema, urmaresteSistemul, useTemaIntunecata } from './lib/tema'
import { useAuthStore } from './stores/auth'

aplicaTema()
urmaresteSistemul()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

/*
  Datele din memoria paginii sunt ale omului logat. La delogare, la sesiunea expirata sau cand
  intra altcineva in aceeasi fila, se golesc — altfel urmatorul ar vedea cateva secunde pagina de
  start a celui dinainte, cu sumele lui (14.10.2026). Doar la plecarea unui om, nu la prima logare.
*/
useAuthStore.subscribe((acum, inainte) => {
  if (inainte.user && inainte.user.id !== acum.user?.id) queryClient.clear()
})

/**
 * `whitespace-pre-line`: erorile venite din ExpertAccounts au o listă pe rânduri — ce produs
 * lipsește și cât. Fără asta ajungeau toate într-o singură linie continuă.
 * `theme` urmează tema paginii: notificările au culorile lor și altfel rămân albe pe întunecat.
 */
function Notificari() {
  const intunecat = useTemaIntunecata()
  return (
    <Toaster
      position="top-right"
      richColors
      theme={intunecat ? 'dark' : 'light'}
      toastOptions={{ className: 'whitespace-pre-line' }}
    />
  )
}

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found')

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ConfirmareProvider>
          <App />
        </ConfirmareProvider>
        <Notificari />
        <AvizVersiuneNoua />
        {/* Dupa App: deasupra formularului care a dat peste dublura. */}
        <FereastraDublura />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
